/**
 * Balance UI store — tracks which balance is selected and whether the
 * balance-switcher modal is open. Persisted so the selected balance
 * survives page refreshes.
 */

import { create, type StateCreator } from 'zustand'
import { persist } from 'zustand/middleware'

interface BalanceState {
  isOpenChangeBalance: boolean
  selectedBalance:     number
  openChangeBalance:   () => void
  closeChangeBalance:  () => void
  setSelectedBalance:  (value: number) => void
  clearBalance:        () => void
}

const storeApi: StateCreator<BalanceState> = set => ({
  isOpenChangeBalance: false,
  selectedBalance:     0,
  openChangeBalance:   () => set({ isOpenChangeBalance: true  }),
  closeChangeBalance:  () => set({ isOpenChangeBalance: false }),
  setSelectedBalance:  (value) => set({ selectedBalance: value }),
  clearBalance:        () => set({ selectedBalance: 0 }),
})

export const useBalanceStore = create<BalanceState>()(
  persist(storeApi, { name: 'balance-store' })
)
